
// ROUTES
require('modules/media/routes/media');

// CONTROLLERS
require('modules/media/controllers/media');
require('modules/media/controllers/list');

// SERVICES
require('modules/media/services/media');
require('modules/media/services/list');
require('modules/media/services/edit');
require('modules/media/services/delete');


angular.module('unica_media', [

	'infinite-scroll',
	'angular-confirm',
	'bootstrapLightbox',

	// ROUTES
	'unica_media.media_routes',

	// CONTROLLERS
	'unica_media.media_controllers',

	// SERVICES
	'unica_media.media_services'

]);